import * as req from '../../../../packages/src/api/organization.js';
import initData from './data.js';

export default initData({ req });
